/// <amd-module name="TFS/Token/PatTokenPage/Actions/PanelActionCreator" />
import { Action } from "VSS/Reflux/Action";
import { Token } from "Models/Token";

export const enum PanelOperationType {
    Add,
    Edit,
    Success,
    ConfirmRevoke,
    ConfirmRegenerate
}

export class PanelDispatcherHub {
    public panelClosed = new Action<{ operation: PanelOperationType }>();
    public tokenPanelOpened = new Action<{ token?: Token, operation: PanelOperationType }>();
}

export class PanelActionCreator {

    public static getInstance(): PanelActionCreator {
        if (!PanelActionCreator._instance) {
            PanelActionCreator._instance = new PanelActionCreator();
        }
        return PanelActionCreator._instance;
    }

    private static _instance: PanelActionCreator;

    public dispatchers: PanelDispatcherHub = new PanelDispatcherHub();

    public readonly openTokenPanel = (operation: PanelOperationType, token?: Token) => {
        this.dispatchers.tokenPanelOpened.invoke({ token, operation });
    }

    public readonly closeTokenPanel = (operation: PanelOperationType) => {
        // do nothing because there is no processing
        this.dispatchers.panelClosed.invoke({ operation });
    }
}
